export enum LiveChatSessionStorageIds {
  DISABLE_FORCED_APP_BANNER = 'mc_disable_forced_app_banner',
}
